import { Associate } from '../associates/associate.model';
import { AppointmentCase } from './appointment-case.model';
import { AppointmentIntegrationData } from './appointment-integration-data.model';
import { AppointmentStatus } from './appointment-status.model';
import { Customer } from '../associates/customer.model';
import { DiagnosticTroubleCode } from '../fixed-operations/diagnostic-trouble-code.model';
import { Employee } from '../associates/employee.model';
import { OemRooftopLink } from '../system/oem-rooftop-link.model';
import { ServiceAppointmentDeclinedMpviCode } from './service-appointment-declined-mpvi-code.model';
import { ServiceCode } from './service-code.model';
import { TechnicianGroup } from '../associates/technician-group.model';
import { TransportOption } from './transport-option.model';
import { Vehicle } from '../vehicle/vehicle.model';

export class Appointment {
  alternateTransportationId: number = null;
  cadillacConcierge: boolean = null;
  cadillacConciergePickup: string = null;
  cadillacConciergeDropoff: string = null;
  cadillacConciergeUsePickupLocation: boolean = null;
  cadillacConciergeContactPhone: string = null;
  callCenterBooked: boolean = null;
  callWhenReady: boolean = null;
  campaignsFound: number = null;
  communicatorExcludeFrom: boolean = null;
  communicatorMissedAptNotificationTime: Date = null;
  communicatorReminderSent: Date = null;
  customerId: string = null;
  customerName: string = null;
  customerVerified: boolean = null;
  dateIn: Date = null;
  dateTime: Date = null;
  department: string = null;
  digitalCheckInStatus: DigitalCheckInStatuses = null;
  embedded?: AppointmentEmbed = null;
  employeeId: string = null;
  externalAppointmentUrl: string = null;
  fordCudbSent: boolean = null;
  fordCudbSentTime: Date = null;
  gmMroMileage: number = null;
  id: number = null;
  ivhUsed: boolean = null;
  ivhDateUsed: Date = null;
  ivhXml: string = null;
  ivhXmlTimestamp: Date = null;
  lastEightVin: string = null;
  lastModified: Date = null;
  licenseNumber: string = null;
  loanerRequired: boolean = null;
  needRide: boolean = null;
  odometerIn: number = null;
  odometerUpdatedByVehicleDiagnostic: boolean = null;
  originalDate: Date = null;
  partsAvailable: boolean = null;
  phoneNumber: string = null;
  pickUp: boolean = null;
  priorityNumber: number = null;
  promisedDateTime: Date = null;
  promisedTime: string = null;
  recallLookupJson: string = null;
  recallLookupTimestamp: Date = null;
  rooftopId: number = null;
  rewardsIndicator: boolean = null;
  serialNumber: string = null;
  serviceAdvisorId: string = null;
  serviceCampaignLookupJson: string = null;
  serviceCampaignLookupTimestamp: Date = null;
  serviceCode: string = null;
  serviceVisitId: string = null;
  sourceId?: number = null;
  startTime: Date = null;
  statusId: number = null;
  tagNumber: string = null;
  technicianGroupId: number = null;
  technicianGroupName: string = null;
  technicianId: string = null;
  tempRequestSymptoms: string = null;
  totalCases: number = null;
  totalEstimatedTime: number = null;
  transportOptionId: number = null;
  unitOfMeasurementId: string = null;
  vendorAppointmentChangedSinceLastOpen: boolean = null;
  vendorAppointmentId: number = null;
  vendorAppointmentXml: string = null;
  vendorCustomerEmail: string = null;
  vendorCustomerFirstName: string = null;
  vendorCustomerLastName: string = null;
  vendorName: string = null;
  vendorVehicleMake: string = null;
  vendorVehicleModel: string = null;
  vendorVehicleYear: Date = null;
  vehicleDescription: string = null;
  vehicleId: number = null;
  vehicleYear: string = null;
  vehicleMake: string = null;
  vehicleVin: string = null;
  warrantyBlockFlag: string = null;
  warrantyBlockLookupDatetime: Date = null;

  constructor(obj?: Appointment) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class AppointmentEmbed {
  appointmentIntegrationData?: AppointmentIntegrationData = null;
  cases?: AppointmentCase[] = null;
  customer?: Customer = null;
  customerAssociate?: Associate = null;
  diagnosticTroubleCodes?: DiagnosticTroubleCode[] = null;
  employee?: Employee = null;
  employeeAssociate?: Associate = null;
  oemRooftopLink?: OemRooftopLink = null;
  serviceAdvisorAssociate?: Associate = null;
  serviceAppointmentDeclinedMpviCodes?: ServiceAppointmentDeclinedMpviCode[] = null;
  serviceCode?: ServiceCode = null;
  status?: AppointmentStatus = null;
  technicianGroup?: TechnicianGroup = null;
  transportOption?: TransportOption = null;
  vehicle?: Vehicle = null;
}

export enum DigitalCheckInStatuses {
  CheckedIn = 'CHECKED_IN',
  Awknowledged = 'ACKNOWLEDGED',
}
